import { useCallback, useEffect, useState } from 'react'
import { useLazyFindItemsEspañaQuery } from '../../slice'
import { indexedDB } from '../../useIndexedDB'
import { ItemEspañaENTITY } from 'sigo-entities'

interface Params {
    pipeline: any[]
}

export const useItemsEspañaRepository = ({ pipeline }: Params) => {
    const [findItemsEspaña, { isError, error }] = useLazyFindItemsEspañaQuery()

    const [data, setData] = useState<ItemEspañaENTITY[]>([])
    const [loading, setLoading] = useState(false)

    const loadData = useCallback(async () => {
        setLoading(true)
        try {
            // ONLINE
            if (navigator.onLine) {
                const response = await findItemsEspaña({ pipeline }).unwrap()
                const now = Date.now()

                await indexedDB.items_españa.bulkPut(
                    response.map((item) => ({
                        ...item,
                        pendingSync: 0,
                        syncedAt: now,
                        updatedAt: now
                    }))
                )

                setData(response)
                return response
            }

            // OFFLINE
            const localData = await indexedDB.items_españa.toArray()
            setData(localData)
            return localData
        } finally {
            setLoading(false)
        }
    }, [findItemsEspaña])

    // AUTO LOAD
    useEffect(() => {
        loadData()
    }, [loadData])

    return {
        currentData: data,
        isLoading: loading,
        isError,
        error,
        reload: loadData
    }
}